import React, { memo } from 'react';
import { Skeleton, Spin } from 'antd';
import { AssetReviewItemDto } from '@api/Api';

import { InfiniteScroll } from '@components/InfiniteScroll/InfiniteScroll';
import LottieComponent from '@components/Lottie';
import AssetLinksTable from '@components/Tables/AssetLinksTable/AssetLinksTable';

import './SharedLinksTab.less';

type SharedLinksTabProps = {
  loading: boolean;
  assetReviewsData: { node: AssetReviewItemDto; cursor: string }[];
  isFetchingNextPage: boolean;
  hasNext: boolean;
  fetchNextPage: () => void;
  campaignId: string;
  hasActiveFilter: boolean;
  canManageReviews: boolean;
};

export default memo(function SharedLinksTab({
  loading,
  assetReviewsData,
  isFetchingNextPage,
  hasNext,
  fetchNextPage,
  campaignId,
  hasActiveFilter,
  canManageReviews
}: SharedLinksTabProps) {
  return (
    <div
      className="shared-links-tab"
      style={{ height: 'calc(100vh - 352px)', overflow: 'auto' }}
    >
      <InfiniteScroll
        loading={isFetchingNextPage ? 'more' : false}
        next={fetchNextPage}
        hasMore={hasNext ?? false}
        loader={
          <>
            <Skeleton.Input />
            <Skeleton.Input />
          </>
        }
      >
        {loading && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%'
            }}
          >
            <Spin size="large" />
          </div>
        )}
        {!assetReviewsData?.length && !!hasActiveFilter && !loading && (
          <div className="empty_state empty_state--search">
            <LottieComponent className="icon" view="noSearchingResult" />
            <strong
              className="main-body-text main-body-text--bold"
              style={{ marginBottom: 8 }}
            >
              No results found
            </strong>
            <p className="copy main-body-text main-body-text--dark-gray">
              It seems we can’t find any results based on your search
            </p>
          </div>
        )}
        {!assetReviewsData?.length && !hasActiveFilter && !loading && (
          <div className="empty_state empty_state--search">
            <LottieComponent className="icon" view="addMediaInFolder" />
            <strong
              className="main-body-text main-body-text--bold"
              style={{ marginBottom: 8 }}
            >
              No links found
            </strong>
            <p className="copy main-body-text main-body-text--dark-gray">
              Looks like there are no links in this project yet
            </p>
          </div>
        )}
        {!!assetReviewsData.length && !loading && (
          <AssetLinksTable
            linksData={assetReviewsData}
            loading={loading}
            campaignId={campaignId}
            canManageReviews={canManageReviews}
          />
        )}
      </InfiniteScroll>
    </div>
  );
});
